import { etapaInfo, estadoInfo, TIPOS, statusStyle } from "@/lib/api";

const base = "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap";

export const StatusPill = ({ value, testId }) =>
  value ? (
    <span data-testid={testId} className={base} style={statusStyle(value) || { borderColor: "#E2E8F0", color: "#334155" }}>{value}</span>
  ) : (
    <span data-testid={testId} className="text-slate-300 text-xs">—</span>
  );

export const StageBadge = ({ etapa, testId }) => {
  const e = etapaInfo(etapa);
  return <span data-testid={testId} className={`${base} ${e.cls}`}>{e.label}</span>;
};

export const EstadoBadge = ({ estado, testId }) => {
  const e = estadoInfo(estado);
  return <span data-testid={testId} className={`${base} ${e.cls}`}>{e.label}</span>;
};

export const TipoBadge = ({ tipo, estado, testId }) => {
  const t = TIPOS[tipo];
  if (!t) return null;
  const off = estado === "finalizado" || estado === "baja";
  return (
    <span data-testid={testId} className={`${base} ${t.cls} ${off ? "opacity-50 line-through" : ""}`}>
      <t.icon className="h-3 w-3" />
      {t.single}
    </span>
  );
};

export const PageTitle = ({ title, subtitle, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6 fade-up">
    <div>
      <h1 className="font-[Outfit] text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
